// extracted by mini-css-extract-plugin
module.exports = {"opaque":"PictoBar_opaque__9Rpdr"};